<template>
  <div>
    <v-card v-if="checkaccessdata.has_download == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="ma-4" max-width="100%" elevation="0" v-else>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Export Details</v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :headers="headersExport"
          :items="DownloadDetailData"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{
              DownloadDetailData.indexOf(item) + 1
            }}</span>
          </template>
          <template v-slot:[`item.generated_on`]="{ item }">
            <span class="caption">{{ item.generated_on }}</span>
          </template>
          <template v-slot:[`item.initiator`]="{ item }">
            <span class="caption" v-if="item.initiator != ''">{{
              item.initiator
            }}</span>
            <span v-else> - </span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span class="caption blue--text" v-if="item.status == 'Pending'">{{
              item.status
            }}</span>
            <span class="caption green--text" v-if="item.status == 'Ready'">
              {{ item.status }}
            </span>
          </template>
          <template v-slot:[`item.export_url`]="{ item }">
            <span class="caption black--text">{{
              item.export_url.split("/")[5]
            }}</span>
          </template>
          <template v-slot:[`item.actionsexport`]="{ item }">
            <v-icon
              :disabled="item.status != 'Ready'"
              small
              color="secondary"
              @click="download(item)"
              :loading="downloadLoading"
              >mdi-download</v-icon
            >
            <!-- </v-btn>
            <v-btn x-small depressed color="transparent" class="ml-n5"> -->
            <v-icon
              small
              color="primary"
              @click="ExportDetails(item)"
              class="ml-3"
              >mdi-eye</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="exportdetails" max-width="600">
      <v-card>
        <v-toolbar flat class="header" dense dark>
          <span class="ml-3">FILTER DETAILS</span>

          <v-spacer></v-spacer>
          <v-btn class text dark @click="exportdetails = false">
            <v-icon small color="white" class="ml-8"> mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card
            elevation="1"
            width="600"
            height="auto"
            class="mb-4 mt-6"
            rounded="xl"
          >
            <v-row>
              <v-col cols="12" md="7" lg="7" xl="7">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">User Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="
                        Filters.user_name != null && Filters.user_name != ''
                      "
                    >
                      {{ Filters.user_name }}
                    </span>
                    <span class="caption" v-else> NA </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Transaction Type</b>
                    </span>
                    <br />
                    <span class="caption" v-if="Filters.txn_name != null">
                      {{ Filters.txn_name }}
                    </span>
                    <span class="caption" v-else> NA </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Status</b>
                    </span>
                    <br />
                    <div v-if="Filters.status != null && Filters.status != ''">
                      <span
                        v-if="Filters.status == 'Unclaimed'"
                        class="orange--text"
                      >
                        {{ Filters.status }}
                      </span>
                      <span
                        v-if="Filters.status == 'Claimed'"
                        class="green--text"
                      >
                        {{ Filters.status }}
                      </span>
                      <span
                        v-if="Filters.status == 'Rejected'"
                        class="red--text"
                      >
                        {{ Filters.status }}
                      </span>
                      <span
                        v-if="Filters.status == 'In progress'"
                        class="black--text"
                      >
                        {{ Filters.status }}
                      </span>
                      <span
                        v-if="Filters.status == 'All transactions'"
                        class="blue--text"
                      >
                        {{ Filters.status }}
                      </span>
                    </div>
                    <div v-else>
                      <span class="caption"> NA </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="5" lg="5" xl="5">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">From Date</b>
                    </span>
                    <br />
                    <span class="caption" v-if="Filters.from_date != null">
                      {{ Filters.from_date }}
                    </span>
                    <span class="caption" v-else> NA </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">To Date</b>
                    </span>
                    <br />
                    <span class="caption" v-if="Filters.to_date != null">
                      {{ Filters.to_date }}
                    </span>
                    <span class="caption" v-else> NA </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    downloadLoading: false,
    DownloadDetailData: [],
    transactionType: "1",
    transactionList: [
      {
        text: "Customer Transactions",
        value: "1",
      },
      {
        text: "Card Transactions",
        value: "11",
      },
    ],
    headersExport: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "sl_no",
      },
      {
        text: "Generated On",
        align: "start",
        sortable: false,
        value: "generated_on",
      },
      {
        text: "Generated By",
        align: "start",
        sortable: false,
        value: "initiator",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: "Actions",
        value: "actionsexport",
        align: "start",
        sortable: false,
      },
    ],
    exportdetails: false,

    Filters: {},
    panel: [0, 1],
    checkaccessdata: {},
  }),
  created() {
    this.checkaccess();
  },
  methods: {
    async getDownloadData() {
      var inputData = {
        method_name: "CTRANS",
        page_no: this.pageCount,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GET_EXPORT_DETAILS",
          export_type: "1",
          export_from: "2",
          corp_id: this.$store.getters.get_corpid, //"16", //"4",
          logged_user_id: this.$store.getters.get_userid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null) {
        this.DownloadDetailData = responseData.data.data;
      }
    },
    BacktoCstTrans() {
      this.count = 0;
    },
    exportdetailsclose() {
      this.exportdetails = false;
    },

    async ExportDetails(item) {
      var inputData = {
        method_name: "CTRANS",
        page_no: this.pageCount,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GET_FILTER_DETAIL",
          export_id: item.export_id,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null) {
        this.Filters = responseData.data.data;
      }

      // this.ExportsItems = item.filter;
      // this.Filters = JSON.parse(this.ExportsItems);
      // console.log(this.Filters);
      this.exportdetails = true;
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CRDTRANS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        // this.getFundDetails(this.end_data, this.enddata);
        this.getDownloadData();
      }
    },
    download(item) {
      this.downloadLoading = true;
      if (item.export_url) {
        window.open(item.export_url);
      }
      this.downloadLoading = false;
    },
  },
};
</script>
